import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "./redux/store";
import RouteComponent from "./Routes/route";
import boozLogo from "../src/image/boozLogo.png";
import { useEffect, useState } from "react";

function App() {
  const [faviconUrl] = useState(boozLogo);
  useEffect(() => {
    const link =
      document.querySelector("link[rel*='icon']") ||
      document.createElement("link");
    link.rel = "icon";
    link.href = faviconUrl;
    document.head.appendChild(link);
  }, [faviconUrl]);
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <RouteComponent />
      </PersistGate>
    </Provider>
  );
}

export default App;
